import "core-js/stable";
import "regenerator-runtime/runtime";
import { async } from "regenerator-runtime";
import { mark } from "regenerator-runtime";

import ring90spin from "../../icons/loading/90-ring.svg";
import ionClose from "../../icons/ionicons/close-outline.svg";
import ionSearch from "../../icons/ionicons/search-outline.svg";

class searchView {
  overlay = document.querySelector(".overlay");
  #btnElement = document.querySelector(".btn-search");
  searchBar = document.getElementById("autocomplete");
  bookmarks = document.querySelector(".bookmark-list");
  bookmarksIcon = document.querySelector(".bookmark-icon-container");
  joinedMarkup = "";
  listMarkup = "";
  bookmarkListOpen = false;

  #data;
  render(data) {
    this.#data = data;
    this.joinedMarkup = "";
    this.joinedMarkup = "";
    this.joinMarkup();
    this.bookmarks.innerHTML = "";
    this.bookmarks.insertAdjacentHTML("afterbegin", this.listMarkup);
    console.log(this.bookmarks);
  }

  renderSpinner() {
    const markup = `
    <img
    src="${ring90spin}"
    alt=""
    class="btn-icon"
  />`;

    this.#clear();
    this.#btnElement.insertAdjacentHTML("afterbegin", markup);
  }

  renderSearchIcon() {
    const markup = `
    <img
    src="${ionSearch}"
    alt=""
    class="btn-icon"
  />`;

    this.#btnElement.removeEventListener("click", function () {
      clearSearch(this.#btnElement);
    });
    this.#clear();
    this.#btnElement.insertAdjacentHTML("afterbegin", markup);
  }

  renderCloseIcon() {
    const markup = `
    <img
    src="${ionClose}"
    alt=""
    class="btn-icon"
  />`;
    this.#clear();
    this.#btnElement.insertAdjacentHTML("afterbegin", markup);
  }

  #clear() {
    this.#btnElement.innerHTML = "";
  }

  #generateMarkup(i) {
    return `<li class="bookmark-selection" data-index="${i}">${
      this.#data.bookmarks[i].placeName
    }</li>`;
  }

  joinMarkup() {
    console.log(this.#data);
    for (let i = 0; i < this.#data.bookmarks.length; i++) {
      this.joinedMarkup = this.joinedMarkup + this.#generateMarkup(i);
    }

    console.log(this.joinedMarkup);
    this.listMarkup = `<ul>${this.joinedMarkup}</ul>`;
    console.log(this.listMarkup);
  }

  addHandlerClear(handler) {
    this.#btnElement.addEventListener("click", function () {
      handler();
    });
  }

  addKeyPressHandler(handler) {
    this.searchBar.addEventListener("keypress", function () {
      handler();
    });
  }

  addHandlerBookmarkIcon() {
    this.bookmarksIcon.addEventListener(
      "click",
      function () {
        console.log(this.#data);
        if (!this.#data || this.#data.bookmarks.length === 0) {
        } else {
          this.bookmarks.classList.toggle("bookmark-list-hidden");
        }
      }.bind(this)
    );
  }

  addDocumentListener() {
    document.addEventListener(
      "click",
      function (e) {
        console.log("document clicked");
        console.log(e);
        const clickEvent = e.target;
        if (
          !this.bookmarks.classList.contains("bookmark-list-hidden") &&
          !clickEvent.classList.contains("bookmarks-list-icon")
        ) {
          console.log("The list is open");
          console.log(clickEvent.classList);
          this.bookmarks.classList.toggle("bookmark-list-hidden");

          console.log(this.bookmarks.classList);
        } else {
          console.log("The list is closed");
        }
      }.bind(this)
    );
  }

  addHandlerBookmarkList(handler) {
    this.bookmarks.addEventListener(
      "click",
      function (e) {
        const bookmark = e.target.closest(".bookmark-selection");

        if (!bookmark) {
          this.bookmarks.classList.toggle("bookmark-list-hidden");
          this._bookmarkListOpen = false;
          return;
        }
        const selectedBookmark = bookmark.dataset.index;
        console.log(bookmark);
        console.log(selectedBookmark);
        handler(selectedBookmark);
      }.bind(this)
    );
  }
}

export default new searchView();
